/* eslint-disable max-len */
import React from 'react'

export default function MVPLogo() {
    return (
        <svg
            width="2785"
            height="837"
            viewBox="0 0 2785 837"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1145.93 664.397L1241.99 184.086H1332.56L1469.1 524.419L1421.07 523.733L1687.3 184.086H1782.68L1687.3 664.397H1583.01L1646.82 342.588H1668.09L1456.07 613.617H1406.67L1293.45 341.902L1314.03 343.96L1250.22 664.397H1145.93ZM1942.67 664.397L1831.51 184.086H1946.1L2042.85 610.188H1970.8L2241.15 184.086H2356.42L2052.46 664.397H1942.67ZM2300.46 664.397L2396.52 184.086H2590.7C2650.63 184.086 2696.83 197.352 2729.31 223.884C2762.24 249.957 2778.71 286.552 2778.71 333.668C2778.71 373.922 2769.34 409.145 2750.58 439.336C2731.83 469.069 2704.84 491.941 2669.61 507.952C2634.85 523.962 2593.45 531.967 2545.42 531.967H2389.66L2448.67 481.192L2412.31 664.397H2300.46ZM2445.93 494.228L2406.82 441.394H2550.22C2586.82 441.394 2615.18 433.16 2635.3 416.693C2655.89 399.768 2666.18 375.295 2666.18 343.275C2666.18 319.945 2658.41 302.791 2642.85 291.813C2627.3 280.377 2605.34 274.659 2576.98 274.659H2441.81L2500.82 220.452L2445.93 494.228Z"
                fill="#1C1F2A"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M861.605 258.962H669.108H529.68H529.601C512.346 258.962 497.326 271.069 493.228 288.278L481.902 335.851H763.858L748.937 398.111C746.875 406.702 739.376 412.74 730.756 412.74H593.261C572.46 412.74 554.416 427.496 549.756 448.314L521.175 566.518H598.556L617.415 489.63H774.699C791.955 489.63 806.975 477.523 811.072 460.314L861.605 258.962Z"
                fill="#FFBE5E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M293.971 258.962C276.638 258.962 261.522 270.931 257.285 288.009L200.061 518.677C194.037 542.96 212.103 566.518 236.747 566.518H422.289C439.622 566.518 454.738 554.551 458.975 537.471L528.067 258.962H293.971ZM334.964 335.851C326.294 335.851 318.734 341.841 316.619 350.384L288.066 465.718C285.061 477.857 294.094 489.63 306.412 489.63H380.665C389.335 489.63 396.895 483.641 399.011 475.097L433.483 335.851H334.964Z"
                fill="#FFBE5E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M972.889 176.711H194.779C193.588 176.711 192.548 177.521 192.259 178.676L75.4794 643.848C75.3065 644.537 75.3673 644.838 75.4012 644.985C75.4591 645.248 75.6161 645.647 75.9509 646.079C76.2856 646.506 76.6373 646.758 76.8758 646.878C77.0136 646.944 77.2898 647.08 78.0003 647.08H852.776C853.969 647.08 855.008 646.265 855.298 645.111L972.889 176.711ZM194.779 101.348C159.034 101.348 127.868 125.657 119.164 160.326L2.38505 625.497C-9.97238 674.718 27.249 722.44 78.0003 722.44H852.776C888.52 722.44 919.686 698.134 928.393 663.462L1069.51 101.348H194.779Z"
                fill="#FFBE5E"
            />
        </svg>
    )
}
